module.exports = __webpack_public_path__ + "static/img/lotteaa.d1df252.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotteaa.png
// module id = a5gE
// module chunks = 0